@if (article && heroPictureURL) {
    <sew-ws-stage-headline-rotation
        [attr.data-preview-id]="article.preview_id"
        (click)="onPictureClicked()"
        [ngStyle]="{ cursor: cursorPointer ? 'pointer' : 'default' }"
        small
    >
        @if (heroPictureURL) {
            <sew-picture object-fit slot="picture" show-image [src]="heroPictureURL.mq3">
                @if (heroPictureURL.mq1 && heroPictureURL.mq1r) {
                    <source
                        media="(max-width:960px)"
                        [attr.srcset]="heroPictureURL.mq1 + ' 1x, ' + heroPictureURL.mq1r + ' 2x'"
                    />
                }
                @if (heroPictureURL.mq2 && heroPictureURL.mq2r) {
                    <source
                        media="(min-width:961px) and (max-width:1344px)"
                        [attr.srcset]="heroPictureURL.mq2 + ' 1x, ' + heroPictureURL.mq2r + ' 2x'"
                    />
                }
                @if (heroPictureURL.mq3 && heroPictureURL.mq3r) {
                    <source
                        media="(min-width:1345px)"
                        [attr.srcset]="heroPictureURL.mq3 + ' 1x, ' + heroPictureURL.mq3r + ' 2x'"
                    />
                }
            </sew-picture>
        }
        <h1>
            <span [innerHTML]="article.headline"></span>
            @if (article.headline_2) {
                <span [innerHTML]="article.headline_2"></span>
            }
        </h1>
        <div slot="tags">
            <blog-tags [tags]="article.tags" [heroImage]="true" (clickTag)="onTagClicked($event)"></blog-tags>
        </div>
        @if (showAuthor) {
            <div
                slot="author"
                class="author-wrapper"
                (click)="onAuthorClicked(article.author); $event.stopPropagation()"
            >
                <img
                    [src]="isRetinaDisplay() ? article.author.avatar.mq1r : article.author.avatar.mq1"
                    [alt]="article.author.hero_picture_alt"
                    class="rounded-circle"
                />
                <div class="author-description">
                    <p>{{ date }} | {{ article.author.firstname + ' ' + article.author.surname }}</p>
                    @if (article.reading_time) {
                        <p>
                            {{ labels?.readingtime }}: {{ article.reading_time }}
                            {{ labels?.readingtime_unit }}
                        </p>
                    }
                </div>
            </div>
        }
    </sew-ws-stage-headline-rotation>
}
@if (breadcrumbs.length > 0) {
    <sew-ws-breadcrumb [links]="breadcrumbs" no-margin="true"></sew-ws-breadcrumb>
}
